import { RootState } from 'duck/store'
import { connect } from 'react-redux'
import { getDeal } from 'scenes/Dashboard/data/deals/selectors'
import { getOrganization } from 'scenes/Dashboard/data/organizations/selectors'

import { getOrganizationDetailsModalState } from '../../duck/selectors'
import OrganizationDetailsView, { OrganizationDetailsViewProps } from './OrganizationDetailsView.presentational'

function mapStateToProps(state: RootState): OrganizationDetailsViewProps {
  const { dealId, organizationId } = getOrganizationDetailsModalState(state)
  const deal = getDeal(state, dealId || undefined)
  const organization = getOrganization(state, organizationId || undefined)

  return {
    organization,
    deal,
  }
}

export default connect(mapStateToProps, null)(OrganizationDetailsView)
